import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const CTABand = ({
  title,
  heading = "Ready to secure your business?",
  copy = "Get a free consultation with our engineers. No obligations, just a clear assessment of where you stand.",
  primary = { label: "Get a Consultation", to: "/contact" },
  secondary = { label: "View All Services", to: "/services" },
}) => (
  <section className="relative overflow-hidden border-t border-white/10 bg-[#0D1322]" data-testid="cta-band">
    <div className="glow-orb left-1/2 top-1/2 h-[420px] w-[720px] -translate-x-1/2 -translate-y-1/2 bg-[#4C5A8C]/20" aria-hidden />
    <div className="relative mx-auto max-w-4xl px-5 py-16 text-center sm:px-8 sm:py-24 lg:py-32">
      <Reveal>
        <h2 className="font-display text-[1.75rem] font-bold leading-[1.15] tracking-tight text-white sm:text-4xl lg:text-5xl lg:leading-[1.1]" data-testid="cta-band-heading">
          {title ? (
            <>
              {title.pre}
              <span className="text-[#8E9AEA]">{title.accent}</span>
            </>
          ) : (
            heading
          )}
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-[#DDE3F2] sm:text-lg">{copy}</p>
        <div className="cta-row mt-9 sm:justify-center">
          <Link to={primary.to} className="btn-primary" data-testid="cta-band-primary">
            {primary.label}
            <ArrowRight className="h-4 w-4" />
          </Link>
          <Link to={secondary.to} className="btn-secondary" data-testid="cta-band-secondary">
            {secondary.label}
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
